<template>
  <BaseModal @close="$emit('close')">
    <template v-slot:title>
      <span class="text-danger">Cancelar Pedido #{{ pedido.id }}</span>
    </template>
    
    <div class="cancel-modal-content">
      <div class="warning-box">
        <span class="material-icons-outlined icon-warn">warning</span>
        <div>
          <strong>Atenção:</strong> Ação irreversível.
        </div>
      </div>
      
      <div v-if="pedido.status === 'approved'" class="cancel-context">
        <p>Este pedido consta como <strong>PAGO</strong>.</p>
        <p>Ao confirmar, o sistema irá:</p>
        <ul>
          <li>Solicitar o <strong>reembolso automático</strong> no Mercado Pago.</li>
          <li>Devolver os itens para o <strong>estoque</strong>.</li>
          <li>Marcar o pedido como <strong>estornado</strong>.</li>
        </ul>
      </div>
      
      <div v-else class="cancel-context">
        <p>Este pedido está <strong>PENDENTE</strong>.</p>
        <p>Ao confirmar, o sistema irá:</p>
        <ul>
          <li>Cancelar a intenção de pagamento.</li>
          <li>Devolver os itens para o <strong>estoque</strong>.</li>
          <li>Marcar o pedido como <strong>cancelado</strong>.</li>
        </ul>
      </div>
    </div>
    
    <template v-slot:actions>
      <button @click="$emit('close')" class="modal-btn-no" :disabled="loading">
        Voltar
      </button>
      <button @click="confirmarCancelamento" class="modal-btn-danger" :disabled="loading">
        {{ loading ? 'Processando...' : 'Confirmar Cancelamento' }}
      </button>
    </template>
  </BaseModal>
</template>

<script>
import api from '@/services/api';
import { AlertBus } from '@/plugins/AlertBus.js';
import BaseModal from '@/components/BaseModal.vue';

export default {
  name: "ModalCancelarPedido",
  components: { BaseModal },
  props: {
    pedido: { type: Object, required: true }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async confirmarCancelamento() {
      this.loading = true;
      try {
        await api.post(`/api/admin/pedidos/${this.pedido.id}/cancelar`);
        const msg = this.pedido.status === 'approved'
          ? 'Pedido estornado e reembolsado com sucesso!'
          : 'Pedido cancelado com sucesso!';
        AlertBus.$emit('show-alert', { message: msg, type: 'success' });
        this.$emit('refresh');
        this.$emit('close');
      } catch (err) {
        const errorText = err.response?.data?.error || err.message;
        AlertBus.$emit('show-alert', { message: `Erro: ${errorText}`, type: 'erro' });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.text-danger { color: #F44336; }
.cancel-modal-content { display: flex; flex-direction: column; gap: 20px; }
.warning-box {
  background-color: rgba(244, 67, 54, 0.1);
  border: 1px solid #F44336;
  color: #F44336;
  padding: 15px;
  border-radius: 8px;
  display: flex; align-items: center; gap: 15px;
}
.icon-warn { font-size: 28px; }
.cancel-context p { margin-bottom: 10px; font-size: 1rem; color: var(--text-main); }
.cancel-context ul { padding-left: 20px; color: var(--text-secondary); }
.cancel-context li { margin-bottom: 5px; }

.modal-btn-no {
  padding: 10px 20px; border-radius: 5px; border: none; cursor: pointer; font-weight: bold; font-size: 1rem;
  background-color: var(--bg-icon-button); color: var(--text-main); border: 1px solid var(--border-light);
  transition: all 0.2s;
}
.modal-btn-no:hover:not(:disabled) { background-color: var(--bg-icon-button-hover); }

.modal-btn-danger {
  background-color: #F44336; color: white; padding: 10px 20px; border-radius: 5px; border: none;
  cursor: pointer; font-weight: bold; font-size: 1rem; transition: all 0.2s;
}
.modal-btn-danger:hover:not(:disabled) { background-color: #D32F2F; }
.modal-btn-danger:disabled { opacity: 0.6; cursor: not-allowed; }
</style>